export function projectSessionFields({ projectName, bpm, totalBars, keySignature }) {
  return { name: projectName, bpm, total_bars: totalBars, key_signature: keySignature || null };
}

export function restoredKeySignature(project) {
  return typeof project?.key_signature === 'string' && project.key_signature.trim() ? project.key_signature : null;
}
